/**
 * SAIT-110. Единственная точка монтирования меню в шапке. Открытие из другой
 * Vue-точки (нижняя панель) идёт через общее состояние; обработчики снимаются.
 */
import { watch, onMounted, onBeforeUnmount } from 'ui.vue3';
import { searchState } from '../search/search-state';
import { acquireOverlayBodyLock } from '../../services/overlay-body-lock';
import { mobileMenuState, closeMobileMenu, MobileMenuPanelAsync } from './mobile-menu-state';

export const MobileMenuHost = {
    components: { MobileMenuPanelAsync },
    setup() {
        let releaseBodyLock = null;
        const stop = watch(() => mobileMenuState.open, (open) => {
            if (open && !releaseBodyLock) {
                releaseBodyLock = acquireOverlayBodyLock();
            } else if (!open && releaseBodyLock) {
                releaseBodyLock();
                releaseBodyLock = null;
            }
        });
        const stopSearch = watch(() => searchState.open, (open) => {
            // Поисковая панель выводится поверх сайта со своим z-index;
            // закрываем меню только после готовности поиска, чтобы она не
            // оказалась за полноэкранным экраном меню.
            if (open && mobileMenuState.open) {
                closeMobileMenu(false);
            }
        });
        const onKeydown = (event) => {
            if (event.key === 'Escape' && (mobileMenuState.open || mobileMenuState.pending)
                && !searchState.open && !searchState.pending) {
                closeMobileMenu();
            }
        };
        // Отдельная функция, а не closeMobileMenu напрямую: браузер передаёт
        // обработчику объект события, и он попал бы в параметр restoreFocus.
        const onPopstate = () => closeMobileMenu();
        onMounted(() => {
            document.addEventListener('keydown', onKeydown, true);
            window.addEventListener('popstate', onPopstate);
        });
        onBeforeUnmount(() => {
            stop();
            stopSearch();
            document.removeEventListener('keydown', onKeydown, true);
            window.removeEventListener('popstate', onPopstate);
            if (releaseBodyLock) {
                releaseBodyLock();
            }
        });
        return { mobileMenuState, closeMobileMenu };
    },
    template: `
        <MobileMenuPanelAsync v-if="mobileMenuState.open"
            :entry="mobileMenuState.entry" @close="closeMobileMenu" />
    `,
};
